module.exports = __webpack_public_path__ + "static/media/commissions2.e1a53e9f.png";